import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import { Toaster } from 'sonner';

// Pages
import PublicHomePage from './pages/PublicHomePage';
import WhyJoin from './pages/WhyJoin';
import Login from './pages/Login';
import Register from './pages/Register';
import InfluencerProfile from './pages/InfluencerProfile';
import InfluencerDashboard from './pages/InfluencerDashboard';
import BrandDashboard from './pages/BrandDashboard';
import AdminDashboard from './pages/AdminDashboard';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicHomePage />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/influencer/:id" element={<InfluencerProfile />} />
            
            {/* Protected Routes - Influencer */}
            <Route 
              path="/dashboard/influencer" 
              element={
                <ProtectedRoute allowedRoles={['influencer']}>
                  <InfluencerDashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* Protected Routes - Brand */}
            <Route 
              path="/dashboard/brand" 
              element={
                <ProtectedRoute allowedRoles={['brand']}>
                  <BrandDashboard />
                </ProtectedRoute>
              } 
            />
            
            {/* Protected Routes - Admin */}
            <Route 
              path="/dashboard/admin" 
              element={
                <ProtectedRoute allowedRoles={['admin']}>
                  <AdminDashboard />
                </ProtectedRoute>
              } 
            />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;